<!--
/**
  * 适应多个分页组件的表格
  * @author weili
  * @date 2023-07-19

       */
-->
<template>
  <div>
      <EXTable
          :api="api"
          :params="params"
          :paramsException="paramsException"
          :size="size"
          :tableData="tableData"
          :boxHeight="boxHeight"
          :tableHeadConfig="tableHeadConfig"
          :selection="selection"
          :indexable="indexable"
          :align="align"
          :maxHeight="maxHeight"
          :loading="hasLoad"
          :defaultSort="defaultSort"
          :cellStyle="cellStyle"
          :hasTableBtns="hasTableBtns"
          :hasDesc="hasDesc"
          :spanMethod="spanMethod"
          :headerRowable="headerRowable"
          :hasTotalRow="hasTotalRow"
          :totalRowText="totalRowText"
          @sortChange="sortChange"
          @selectionChange="selectionChange"
          @currentChange="currentChange"
          @rowClick="rowClick"
        >
        <!--表格插槽数组-->
        <template :slot="item" v-for="item in slotGroup" slot-scope="scope">
            <slot :name="item" :scope="scope" />
        </template> 
      </EXTable>
  </div>
</template>
<script>
import EXTable from "@/components/EXTable";
import getMultiList from "@/mixins/getMultiList";
export default {
  name: 'EXMultiTable',
  components: {
     EXTable
  },
  mixins: [getMultiList],
  props: {
    // 请求接口
    api: {
      type: Function,
      default: null
    },
    // 参数  默认返回分页和条数
    params: {
      type: Object,
      default: {
        pageNum: 1,
        pageSize: 10
      },
    },
    //过滤后端不需要的参数
    paramsException :{
        type: Array,
        default: ()=>([])
    },
    //请求接口返回数据后调用父组件的方法
    dataCallBackFn:Function,
    // 尺寸
    size: {
      default: "small",
    },
    // 表格数据,
    tableData: {
      type: Array,
    },
    // 整体右侧盒子高度
    boxHeight: {
      type: String
    },
    // 表格对应的列的内容
    tableHeadConfig: {
      type: Array,
    },
    // 表格是否可多选
    selection: {
      type: Boolean,
      default: false,
    },
     // 表格是否显示序号列
     indexable: {
      type: Boolean,
      default: true,
    },
    // 表格内容是否居中
    align: {
      type: String,
      default: "center",
    },
    //限制最大高度
    maxHeight: String,
    hasLoad: {
      // loading动画
      type: Boolean,
      default: false,
    },
    //default-sort
    defaultSort:{
      type: Object
    },
    //cell-style
    cellStyle:{
      type:Function
    },
    //表格上方是否有操作按钮行
    hasTableBtns: {
      type: Boolean,
      default: false,
    },
    //表格上方是否有文字描述行
    hasDesc: {
      type: Boolean,
      default: false,
    },
    //数据跨行
    spanMethod:{
      type:Function
    },
    //是否隐藏表头第二行
    headerRowable:{
      type: Boolean,
      default: false,
    },
    //表格插槽名称字符串数组
    slotGroup: {
      type: Array,
      default: () => ([])
    },
     //是否具有合计行：隐藏序号
     hasTotalRow: {
      type: Boolean,
      default: false
    },
    //合计行名称
    totalRowText: {
      type: String,
      default: "合计",
    }
  },
  data() {
    return {
      loading: this.hasLoad
    };
  },
  watch:{
	  hasLoad(val, valOld){  // 这里也可以在 data 定义变量 并将 father 赋值给他， 在这里监控这个变量
	    // 这里做如果 father 变量变化了，子组件需要处理的逻辑
      this.loading = val
	  }
	},
  mounted(){
  },
  methods: {
    dataCallBack(res){
      this.$emit("dataCallBackFn",res);
    },
    selectionChange(val) {
      this.$emit("selection-change", val);
    },
    // 单选
    currentChange(currentRow, oldCurrentRow) {
      this.$emit("current-change", currentRow, oldCurrentRow);
    },
    rowClick(row, event, column) {
      this.$emit("row-click", row, event, column);
    },
    // 排序
    sortChange(column, prop, order) {
      this.$emit("sort-change", column, prop, order);
    }
  }
}
</script>
 <style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/EXTable/multiTable.vue